import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  HostListener,
} from '@angular/core';
import {
  HttpClient,
  HttpClientModule,
  HttpHeaders,
} from '@angular/common/http';
import { CommonModule } from '@angular/common';
import swal from 'sweetalert2';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { Response } from '@angular/http';
import { ApidataService } from '../apidata.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { Ng2SearchPipeModule } from '@ngx-maintenance/ng2-search-filter';
import { FormsModule } from '@angular/forms';
import { NgPipesModule, ReversePipe } from 'ngx-pipes';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { OpenSidebarComponent } from '../open-sidebar/open-sidebar.component';
import { environment, GINConstants } from '../../environments/environments';
import { ActivatedRoute } from '@angular/router';
import jsPDF from 'jspdf';

declare var $: any;
declare var Dropbox: any;
declare var gapi: any;
declare var google: any;
declare var FB: any;
declare var window: any;
@Component({
  selector: 'app-openfile',
  standalone: true,

  imports: [
    HttpClientModule,
    CommonModule,
    NgxPaginationModule,
    NgbPaginationModule,
    FormsModule,
    PaginationModule,
    NgPipesModule,
    FilterPipeModule,
    Ng2SearchPipeModule,
    OpenSidebarComponent,
  ],
  templateUrl: './openfile.component.html',
  styleUrl: './openfile.component.css',
  providers: [ApidataService],
})
export class OpenfileComponent implements OnInit, AfterViewInit {
  public dataListings2: any[] = [];
  profile_id;
  @ViewChild('fileInput') fileInput;
  public all_records = [];
  docTitle2 = '';
  doc_id;
  checkdate = [];
  public titlelist = [];
  dataListings;
  itemsCopy;
  savefiletexts;
  public checkbackdoclink;
  public searchforopen;
  public checkresponse;
  todayDate: string;

  assistantVisible: boolean = false;
  isDropdownOpen = false;
  public char_count = 0;
  word_count = 0;
  public spanwords = [];
  public gotresponse: boolean = false;
  public editortext = '';
  public showbuttons: boolean = false;
  public loaderAlert: boolean = false;
  public menuafterresponse: boolean = false;
  public copiedtext: boolean = false;
  popupVisible = false;
  popupPosition: any;

  totalItems = 30; // total number of items
  currentPage = 1; // default starting page
  itemsPerPage = 11; // number of items per page
  linessPerPage = 18; // number of items per page
  maxSize = 4;
  paginatedListings: any[] = [];
  showPagination = false;
  public clientId =
    '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com';
  public scope = [
    'profile',
    'email',
    'https://www.googleapis.com/auth/drive.file', //insert scope here,
  ].join(' ');
  public pickerApiLoaded = false;

  constructor(
    private router: Router,
    private apirequest: ApidataService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const docID = params.get('docID');
      if (docID) {
        this.redirectDocument(docID);
      }
    });

    const date = new Date();
    const day = ('0' + date.getDate()).slice(-2);
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();

    this.todayDate = `${day} ${month} ${year}`;

    localStorage.setItem('todayDate', this.todayDate);

    this.checkbackdoclink = localStorage.getItem('previousdoc');

    this.showGridView = true;
    this.showLineView = false;
    this.showGrid();
  }

  public ngAfterViewInit(): void {
    this.getUserFilesList();
    this.getBrowserWidth();
  }

  ///// go to account settings
  public gotosetting() {
    window.open('/accountsettings', '_blank');
    // this.router.navigate(['/accountsettings']);
  }

  public backtoeditor() {
    // this.router.navigate(['/document/',this.checkbackdoclink])
    this.router.navigate(['/grammar-check'], {
      queryParams: { doc: this.checkbackdoclink },
    });
  }
  //////////  Go to editor
  public gotoeditor(type) {
    let data2 = JSON.stringify({ homeText: '', profile_id: this.profile_id });
    let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';
    this.apirequest.postResources(data2, url).subscribe((data) => {
      let receivedData = data;

      this.doc_id = receivedData['new_doc_id'];
      // this.router.navigate(['/document/', this.doc_id]);
      this.router.navigate(['/grammar-check'], {
        queryParams: { doc: this.doc_id },
      });
      var editortxt = '';

      localStorage.setItem('editorValueAI', editortxt);
      const url = this.router.serializeUrl(this.router.createUrlTree(['']));
    });
  }
  public handleNewDocData5(data: Response) {
    var self = this;

    let receivedData = data;
    this.doc_id = receivedData['new_doc_id'];
    // self.router.navigate(['/document/', self.doc_id]);
    self.router.navigate(['/grammar-check'], { queryParams: { doc: self.doc_id } });
  }
  ///// all files list

  public getUserFilesList() {
    this.profile_id = localStorage.getItem('profile_id');
    this.apirequest.getUserFilesListing(this.profile_id).subscribe(
      (data) => {
        let receivedData = data;

        this.all_records = receivedData['contents'];
        // console.log(  this.all_records,"  this.all_records")
        let date_now = moment.default().format('YYYY-MM-DD HH:mm:ss');
        this.checkdate = [];
        this.dataListings2 = [];
        this.dataListings = [];
        for (let i = 0; i < this.all_records.length; i++) {
          let startDate = new Date(this.all_records[i][8]);
          let endDate = new Date(date_now);
          let seconds = Math.round(
            (endDate.getTime() - startDate.getTime()) / 1000
          );

          if (this.all_records[i][7].length > 0) {
            let title =
              this.all_records[i][6] === ''
                ? 'Untitled Document'
                : this.all_records[i][6];
            this.dataListings.push({
              doc_title: title,
              doc_data: this.all_records[i][7].substring(0, 220).trim(),
              doc_id: this.all_records[i][5],
              doc_url: this.all_records[i][0],
              doc_date: this.all_records[i][8],
              all_errors:
                parseInt(this.all_records[i][2]) +
                parseInt(this.all_records[i][3]) +
                parseInt(this.all_records[i][4]),
            });
          }
        }
      },
      (error) => {
        // console.error('Error fetching user files list', error);
      }
    );
  }

  private handleData(data: Response) {
    let receivedData = data;
    this.all_records = receivedData['contents'];
    var date_now = moment.default().format('YYYY-MM-DD HH:mm:ss');
    this.checkdate = [];
    this.dataListings2 = [];
    this.dataListings = [];
    for (let i = 0; i < this.all_records.length; i++) {
      var startDate = new Date(this.all_records[i][8]);

      var endDate = new Date(date_now);
      var seconds = Math.round(
        (endDate.getTime() - startDate.getTime()) / 1000
      );

      if (this.all_records[i][7].length > 0) {
        let title;
        if (this.all_records[i][6] === '') {
          title = 'Untitled Document';
        } else {
          title = this.all_records[i][6];
        }
        this.dataListings.push({
          doc_title: title,
          doc_data: this.all_records[i][7].substring(0, 220).trim(),
          doc_id: this.all_records[i][5],
          doc_url: this.all_records[i][0],
          doc_date: this.all_records[i][8],
          all_errors:
            parseInt(this.all_records[i][2]) +
            parseInt(this.all_records[i][3]) +
            parseInt(this.all_records[i][4]),
        });
      }
    }
  }
  /////////download file//////////
  public downloadFile(doc_id) {
    this.profile_id = localStorage.getItem('profile_id');
    this.apirequest
      .getDocContentsByDocID(this.profile_id, doc_id)
      .subscribe((data) => this.forceDownloadFile(data));
  }
  private forceDownloadFile(data: Response) {
    let receivedData = data;

    let doc_url = receivedData['contents'][0][5];
    let docTitle = receivedData['contents'][0][15];
    let docContents = receivedData['contents'][0][4];

    const tempEl = document.createElement('div');
    tempEl.innerHTML = `
      ${this.preserveTextAlignment(this.convertBulletListsToUnordered(docContents))}
    `;
    tempEl.style.position = 'absolute';
    tempEl.style.left = '-9999px';
    tempEl.style.top = '0';
    tempEl.id = 'pdf-content';
    document.body.appendChild(tempEl);

    const doc = new jsPDF();

    doc.html(tempEl.innerHTML, {
      callback: (pdf) => {
        pdf.save(`${docTitle}.pdf`);
        document.body.removeChild(tempEl);
      },
      x: 10,
      y: 10,
      width: 180,
      windowWidth: 800,
    });
  }
  public deleteit(file_id) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then(() => {
      this.deleteFileAfterConfirm(file_id);
    });
  }
  /////// delete file/////////
  public deleteFileAfterConfirm(file_id: string) {
    var c = confirm('Are you sure to delete?');
    if (c == true) {
      $('#fileListMsg1_' + file_id).html('&nbsp;');
      $('#fileListMsg2_' + file_id).html('&nbsp;');
      $('#fileListMsg3_' + file_id).html(
        '<img src="assets/images/ajax-loader2.gif">'
      );

      this.apirequest
        .deleteDocumentByID(this.profile_id, file_id)
        .subscribe((data) => {
          this.handleDocDataDeleted(data);
        });
    }
  }
  private handleDocDataDeleted(data: Response) {
    let receivedData = data;
    this.all_records = receivedData['contents'];
    this.savefiletexts = 'File deleted Successfully!';

    this.getUserFilesList();
  }

  //// redirect file
  public redirectDocument(docID: string) {
    // this.router.navigate(["/document/", docID]);
    this.router.navigate(['/grammar-check'], { queryParams: { doc: docID } });
    // console.log('knock knock', docID);
    return false;
  }
  ///// logout
  public logout() {
    this.router.navigate(['']);

    this.apirequest.logout();
    localStorage.clear();
  }

  public gDriveUpload() {
    gapi.load('auth', { callback: this.onAuthApiLoad.bind(this) });
    gapi.load('picker', { callback: this.onPickerApiLoad.bind(this) });
  }
  public onAuthApiLoad() {
    gapi.auth.authorize(
      {
        client_id: this.clientId,
        scope: this.scope,
        immediate: false,
      },
      this.handleAuthResult
    );
  }

  public onPickerApiLoad() {
    this.pickerApiLoaded = true;
  }
  isExport: boolean = false;
  public handleAuthResult(authResult) {
    $('#UpFileModal').modal('hide');
    let src;

    if (authResult && !authResult.error) {
      if (authResult.access_token) {
        let view = new google.picker.View(google.picker.ViewId.DOCS);

        view.setMimeTypes(
          'application/pdf,application/txt,text/plain,application/vnd.oasis.opendocument.text,application/vnd.google-apps.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        );

        let pickerBuilder = new google.picker.PickerBuilder();
        let picker = pickerBuilder
          .enableFeature(google.picker.Feature.MINE_ONLY)
          .setOAuthToken(authResult.access_token)
          .addView(view)
          .addView(new google.picker.DocsUploadView())
          .setCallback(function (e) {
            if (e.action == google.picker.Action.PICKED) {
              var fileId = e.docs[0].id;
              var file = e.docs[0].url;
              var files = e.docs[0];
              if (files.sizeBytes > 5243000) {
                this.lodershow = false;

                swal({
                  background: '#FFFFFF',
                  title: 'Error',
                  html: `
                  <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                    background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                    <div class="text-center" style="margin-top: 9%;">
                      <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                      <div style="width: 323px; height: 64px; margin-left: 77px;">
                        <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                          File should be less than 5 MB
                        </p>
                      </div>
                      <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                        border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                        class="mt-4 butn-alert">Ok</button>
                    </div>
                  </div>
                `,
                  showConfirmButton: false,
                  width: '323px',
                  timer: 4000,
                });

                setTimeout(() => {
                  const okButton = document.getElementById('swal-ok-button');
                  if (okButton) {
                    okButton.addEventListener('click', () => {
                      swal.close();
                    });
                  }
                }, 0);
              } else {
                if (e.docs[0].name.split('.')[1] === 'pdf') {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://drive.google.com/u/0/uc?id=' +
                    fileId +
                    '&export=download';
                  let profile_id = localStorage.getItem('profile_id');
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'pdf',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      let data2 = JSON.stringify({
                        homeText: return_data.RetCnt.replace(/\n/g, '<br>'),
                        profile_id: profile_id,
                      });
                      // console.log("data2", data2)

                      let url =
                        environment.API_URL +
                        '/api/getNewDocIDForGuestByContents';
                      let token = environment.AuthorizationGIN;

                      $.ajax({
                        url: url,
                        type: 'POST',
                        data: data2,
                        contentType: 'application/json',
                        headers: {
                          Authorization: `${token}`,
                        },

                        success: function (receivedData) {
                          // console.log('receivedData', receivedData);

                          if (typeof receivedData === 'string') {
                            try {
                              receivedData = JSON.parse(receivedData);
                              // console.log('Parsed receivedData:', receivedData);
                            } catch (error) {
                              console.error('Error parsing JSON:', error);
                              return;
                            }
                          }

                          let doc_id = receivedData.new_doc_id;
                          // console.log('id check', doc_id);

                          if (!doc_id) {
                            console.error('new_doc_id not found in response');
                          } else {
                            window.location.href = `/document?id=${doc_id}`;
                        
                            var editortxt = '';
                            var parsedData = JSON.parse(data2); 
                            editortxt = parsedData.homeText; 
                            // console.log("check", editortxt);
                            localStorage.setItem('editorValueAI', editortxt);

                          }
                        },
                      });

                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                } else if (e.docs[0].name.split('.')[1] === 'txt') {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://drive.google.com/u/0/uc?id=' +
                    fileId +
                    '&export=download';

                  if (localStorage.getItem('profile_id')) {
                    var profile_id = localStorage.getItem('profile_id');
                  } else {
                    var profile_id = '1';
                  }
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'txt',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      this.hideothers = true;
                      let data2 = JSON.stringify({
                        homeText: return_data.RetCnt.replace(/\n/g, '<br>'),
                        profile_id: profile_id,
                      });
                      // console.log("data2", data2)


                      let url =
                        environment.API_URL +
                        '/api/getNewDocIDForGuestByContents';
                      let token = environment.AuthorizationGIN;

                      $.ajax({
                        url: url,
                        type: 'POST',
                        data: data2,
                        contentType: 'application/json',
                        headers: {
                          Authorization: `${token}`,
                        },

                        success: function (receivedData) {
                        

                          if (typeof receivedData === 'string') {
                            try {
                              receivedData = JSON.parse(receivedData);
                             
                            } catch (error) {
                              console.error('Error parsing JSON:', error);
                              return;
                            }
                          }

                          let doc_id = receivedData.new_doc_id;
                         
                          if (!doc_id) {
                            console.error('new_doc_id not found in response');
                          } else {
                            window.location.href = `/document?id=${doc_id}`;
                        
                            var editortxt = '';
                            var parsedData = JSON.parse(data2); 
                            editortxt = parsedData.homeText.replace(/\n/g, '<br>'); 
                            // console.log("check", editortxt);
                            localStorage.setItem('editorValueAI', editortxt);

                          }
                        },
                      });

                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
                      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                        <div class="text-center" style="margin-top: 9%;">
                          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                          <div style="    width: 369px; height: 64px; margin-left: 39px;">
                            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
                            </p>
                          </div>
                          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                            class="mt-5 butn-alert">Ok</button>
                        </div>
                      </div>
                    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                } else if (e.docs[0].name) {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://docs.google.com/feeds/download/documents/export/Export?id=' +
                    fileId +
                    '&exportFormat=docx';
                  let profile_id = localStorage.getItem('profile_id');
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'docx',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      let data2 = JSON.stringify({
                        homeText: return_data.RetCnt.replace(/\n/g, '<br>'),
                        profile_id: profile_id,
                      });
                      // console.log("data2", data2)

                      let url =
                        environment.API_URL +
                        '/api/getNewDocIDForGuestByContents';
                      let token = environment.AuthorizationGIN;

                      $.ajax({
                        url: url,
                        type: 'POST',
                        data: data2,
                        contentType: 'application/json',
                        headers: {
                          Authorization: `${token}`,
                        },

                        success: function (receivedData) {
                          // console.log('receivedData', receivedData);

                          if (typeof receivedData === 'string') {
                            try {
                              receivedData = JSON.parse(receivedData);
                              // console.log('Parsed receivedData:', receivedData);
                            } catch (error) {
                              console.error('Error parsing JSON:', error);
                              return;
                            }
                          }

                          let doc_id = receivedData.new_doc_id;
                          // console.log('id check', doc_id);

                          if (!doc_id) {
                            console.error('new_doc_id not found in response');
                          } else {

                            window.location.href = `/document?id=${doc_id}`;
                            
                            var editortxt = '';
                            var parsedData = JSON.parse(data2); 
                            editortxt = parsedData.homeText; 
                            // console.log("check", editortxt);
                            localStorage.setItem('editorValueAI', editortxt);
                          }
                        },
                      });

                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
                      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                        <div class="text-center" style="margin-top: 9%;">
                          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                          <div style="    width: 369px; height: 64px; margin-left: 39px;">
                            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
                            </p>
                          </div>
                          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                            class="mt-5 butn-alert">Ok</button>
                        </div>
                      </div>
                    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                }
              }
            }
          })
          .build();
        picker.setVisible(true);
      }
    }
  }

  openDropboxChooser(): void {
    const options = {
      success: (files: any) => {
        let fileType = this.getFileType(files[0].name);

        if (fileType === 'docx' || fileType === 'pdf' || fileType === 'txt') {
          this.uploadFileToServer(files[0].link, fileType);
        } else {
        }
      },
      cancel: () => { },
      linkType: 'direct',
      multiselect: false,
      extensions: ['.docx', '.pdf', '.txt'],
      sizeLimit: 1024 * 1024 * 5,
    };
    Dropbox.choose(options);
  }
  getFileType(fileName: string): string {
    const fileExtension = fileName.split('.').pop();
    return fileExtension ? fileExtension.toLowerCase() : '';
  }
  uploadFileToServer(fileLink: string, fileType: string): void {
    this.word_count = 0;
    this.char_count = 0;
    this.loaderAlert = true;

    this.menuafterresponse = false;

    const headers = new HttpHeaders({
      Authorization: environment.AuthorizationGIN,
    });
    var data = { file_type: fileType, file_path: fileLink };
    this.apirequest.dropboxfile(fileType, fileLink).subscribe((data) => {
      let receivedData = data;

      let data2 = JSON.stringify({
        homeText: receivedData['RetCnt'].replace(/\n/g, '<br>'),
        profile_id: this.profile_id,
      });
      let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';
      this.apirequest.postResources(data2, url).subscribe((data) => {
        let receivedData = data;

        this.doc_id = receivedData['new_doc_id'];
        // this.router.navigate(['/document/', this.doc_id]);
        this.router.navigate(['/grammar-check'], {
          queryParams: { doc: this.doc_id },
        });
      });
    });
  }
  public getContent(event, text) {
    var ctrlDown = false,
      ctrlKey = 17,
      cmdKey = 91,
      vKey = 86,
      cKey = 67;
    this.editortext = text;
    if (ctrlDown && event.keyCode == vKey) {
      var editortxt = $('#mm').text();
    }

    var editortxt = $('#mm').text();
    this.char_count = $('#mm').text().length;
    this.word_count = $('#mm').text().trim().split(' ').length;
  }

  filteredDataListings: any[] = [];
  updateFilteredSuggestions() {
    this.isPlaceholderVisible = false;
    if (this.searchforopen) {
      this.filteredDataListings = this.dataListings.filter(
        (row) =>
          row.doc_title
            .toLowerCase()
            .includes(this.searchforopen.toLowerCase()) ||
          row.doc_data.toLowerCase().includes(this.searchforopen.toLowerCase())
      );
    } else {
      this.filteredDataListings = [...this.dataListings];
    }
  }
  //////////// upload file module////////
  public uploadFileSaveRedirect(event): void {
    var create_chunks = 'false';

    const files: FileList = this.fileInput.nativeElement.files;
    const fileArray: File[] = Array.from(files);

    if (files[0].size > 5243000) {
      this.showAlert('File should be less than 5 MB.', '');
    } else {
      this.loaderAlert = true;
      this.apirequest
        .submitEFile(this.profile_id, fileArray, create_chunks)
        .subscribe((data) => {
          // this.router.navigate(['/document/', data.new_doc_id ]);
          this.router.navigate(['/grammar-check'], {
            queryParams: { doc: data.new_doc_id },
          });
        });
    }
  }

  showLineView: boolean = true;
  showGridView: boolean = false;
  hoveredIcon: string | null = null;
  selectedIcon: string | null = null;

  // Method to  showGrid
  showGrid() {
    this.showLineView = false;
    this.showGridView = true;
    this.selectedIcon = 'grid';
    this.hoveredIcon = null;
  }
  // Method to   showLines
  showLines() {
    this.showLineView = true;
    this.showGridView = false;
    this.selectedIcon = 'lines';
    this.hoveredIcon = null;
  }

  searchText: string = '';
  isPlaceholderVisible: boolean = true;

  onFocus(): void {
    this.isPlaceholderVisible = false;
  }

  onBlur(): void {
    this.isPlaceholderVisible = this.searchText.length === 0;
    if (this.searchforopen.length >= 1) {
      this.isPlaceholderVisible = false;
    }
  }

  error: boolean = false;
  errorAlerts;
  success: boolean = false;
  successAlert;

  showAlert(message, selector) {
    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts').show();
    setTimeout(() => {
      $('#errorAlerts').hide();
      $(selector).css('border-color', '#e7e7ec');
    }, 4000);
  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }
  @Output() close = new EventEmitter<void>();
  closeErrorDiv() {
    this.error = false;
  }

  getBrowserWidth = function () {
    if (window.innerWidth < 768) {
      this.router.navigate(['/notformobile']);

      this.msgforsmallscreen = true;
      return 'xs';
    } else if (window.innerWidth < 991) {
      this.msgforsmallscreen = false;

      return 'sm';
    } else if (window.innerWidth < 1199) {
      this.msgforsmallscreen = false;

      return 'md';
    } else {
      this.msgforsmallscreen = true;
      return 'lg';
    }
  };

  private preserveTextAlignment(html: string): string {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      function updateStyle(className, textAlignValue) {
        doc.querySelectorAll(`.${className}`).forEach(el => {
          (el as HTMLElement).style.textAlign = textAlignValue;
        });
      }

      updateStyle("ql-align-center", "center");
      updateStyle("ql-align-right", "right");
      updateStyle("ql-align-justify", "justify");

      return doc.body.innerHTML;
    }

    private convertBulletListsToUnordered(html: string): string {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      doc.querySelectorAll("ol").forEach((ol) => {
        const listItems = ol.querySelectorAll('li[data-list="bullet"]');

        if (listItems.length > 0) {
          const ul = document.createElement("ul");

          listItems.forEach((li) => ul.appendChild(li));

          ol.replaceWith(ul);
        }
      });

      return doc.body.innerHTML;
    }
}
